import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { QuickViewPopupComponent } from './quick-view-popup.component';
import { DialogModule } from 'primeng/dialog';
import { SidebarModule } from 'primeng/sidebar';
import { AccordionModule } from 'primeng/accordion';
import { ShareButtonsModule } from 'ngx-sharebuttons/buttons';
import { ShareIconsModule } from 'ngx-sharebuttons/icons';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';



@NgModule({
  declarations: [
    QuickViewPopupComponent
  ],
  imports: [
    CommonModule,
    DialogModule,
    SidebarModule,
    AccordionModule,
    FormsModule,
    RouterModule,
     ShareButtonsModule.withConfig({
              debug:true
            }), 
            ShareIconsModule,
  ],
  exports:[QuickViewPopupComponent]
})
export class QuickViewPopupModule { }
